export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/tick.3927e85e.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};